var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.sellerName ? _c('div', {
    staticClass: "seller-header d-none d-md-flex container-fluid justify-content-end"
  }, [_c('div', {
    staticClass: "seller-container mx-3 px-1"
  }, [_c('button', {
    staticClass: "btn-link",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.goToShop(false);
      }
    }
  }, [_c('span', {
    staticClass: "pl-2 pr-1 font-weight-bold text-white text-capitalize text-size"
  }, [_vm._v(_vm._s(_vm.formatSellerName))])]), _vm._v(" "), _c('span', {
    staticClass: "pr-2 pl-1"
  }, [_c('button', {
    staticClass: "text-white btn-link p-0 text-size",
    attrs: {
      "type": "button"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('logout'))
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.handleSellerLogOut();
      }
    }
  })])])]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };